const atualizarOrdensServico = (state, ordensServico) => {
    state.ordensServico = ordensServico;
}

const atualizarOrdemServico = (state, ordemServico) => {
    state.ordemServico = ordemServico;
}

const updateOrdemServico = (state, ordemServico) => {
    if (!ordemServico || ordemServico.id == null) return;

    const index = state.ordensServico.findIndex(item => item.id === ordemServico.id);
    if (index >= 0) {
        state.ordensServico.splice(index, 1, JSON.parse(JSON.stringify(ordemServico)));
    }
}

export default {
    atualizarOrdensServico,
    atualizarOrdemServico,
    updateOrdemServico
}
